import React from 'react';
import {Link} from "react-router-dom";
import {PATH_APP} from "../routes/paths";
import BackIcon from "../assets/back-icon";

export default function Header(props) {
    return (
        <header className={'fixed-top' + " " + props.header}>
            <h6 className="text-center p-4">
                <Link to={props.link} className="float-end">
                    <BackIcon/>
                </Link>
                {props.title}</h6>
        </header>
    );
}